<template>
    <div class="range-slider">
        <span class="range-slider__from">{{ min }}</span>
        <input type="range"
               :min="min"
               :max="max"
               :step="step"
               class="range-slider__picker"
               :value="value"
               @input="updateValue($event.target.value)"/>
        <span class="range-slider__to">{{ max }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            value: Number,
            min: {
                default: 0,
            },
            max: {
                default: 10,
            },
            step: {
                default: 1,
            },
        },
        data () {
            return {
            }
        },
        methods: {
            updateValue (value) {
                this.$emit('input', Number(value));
            }
        },
        mounted() {

        },
    };
</script>


// WEBPACK FOOTER //
// src/components/Code/properties/RangeSlider.vue